module.exports = __webpack_public_path__ + "img/right-double-arrow.ed8ea580.svg";